export default __webpack_public_path__ + "static/media/titulo_diabetes.cd07dd5e.jpg";